import angular from 'angular';

import { TwoFactorAuthLoginCtrl } from './two-factor-auth.login.ajs';
import { TwoFactorAuthStates }    from './two-factor-auth.states.ajs';

angular.module('app.two-factor-auth', [])
.config(TwoFactorAuthStates)
.controller('TwoFactorAuthLoginCtrl', TwoFactorAuthLoginCtrl);
